import { Loader } from '@googlemaps/js-api-loader';

let promise;
let error;
let isLoaded = false;

const load = options => {
  /* istanbul ignore else */
  if (error) {
    throw error;
  }
  /* istanbul ignore else */
  if (!promise) {
    const loader = new Loader(options);
    promise = loader
      .load()
      .then(() => {
        isLoaded = true;
      })
      .catch(() => {
        error = new Error('Failed to load Google Maps script');
      });
  }
  throw promise;
};

export const GoogleMapsLoader = {
  load,
  get isLoaded() {
    return isLoaded;
  },
  get error() {
    return error;
  },
  reset() {
    promise = undefined;
    error = undefined;
    isLoaded = false;
  },
};
